(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yunova-shop-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.yg-shop').forEach((section) => {
    const filterButtons = section.querySelectorAll('[data-filter]');
    const cards = section.querySelectorAll('[data-kind]');
    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.filter;
        filterButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.kind !== filter;
        });
      });
    });

    const spotlight = section.querySelector('[data-yg-spotlight]');
    if (!spotlight) return;

    const slides = Array.from(spotlight.querySelectorAll('[data-spotlight-slide]'));
    const thumbs = Array.from(spotlight.querySelectorAll('[data-spotlight-thumb]'));
    const progress = Array.from(spotlight.querySelectorAll('[data-spotlight-progress]'));
    const previous = spotlight.querySelector('[data-spotlight-prev]');
    const next = spotlight.querySelector('[data-spotlight-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let touchStartX = 0;
    let autoTimer = 0;
    let pointerInside = false;
    let focusInside = false;

    const showSlide = (requestedIndex) => {
      activeIndex = (requestedIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      thumbs.forEach((thumb, index) => {
        const distance = (index - activeIndex + slides.length) % slides.length;
        thumb.classList.toggle('is-preview', distance === 1 || distance === 2);
        thumb.setAttribute('aria-selected', String(index === activeIndex));
      });
      progress.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
      });
    };

    const stopAutoplay = () => {
      window.clearTimeout(autoTimer);
      autoTimer = 0;
    };

    const scheduleAutoplay = () => {
      stopAutoplay();
      if (slides.length < 2 || reducedMotion.matches || pointerInside || focusInside || document.hidden) return;
      autoTimer = window.setTimeout(() => {
        showSlide(activeIndex + 1);
        scheduleAutoplay();
      }, 6500);
    };

    const showManualSlide = (requestedIndex) => {
      showSlide(requestedIndex);
      scheduleAutoplay();
    };

    previous?.addEventListener('click', () => showManualSlide(activeIndex - 1));
    next?.addEventListener('click', () => showManualSlide(activeIndex + 1));
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showManualSlide(Number(thumb.dataset.slideIndex)));
    });
    spotlight.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showManualSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') showManualSlide(activeIndex + 1);
    });
    spotlight.addEventListener('mouseenter', () => {
      pointerInside = true;
      stopAutoplay();
    });
    spotlight.addEventListener('mouseleave', () => {
      pointerInside = false;
      scheduleAutoplay();
    });
    spotlight.addEventListener('focusin', () => {
      focusInside = true;
      stopAutoplay();
    });
    spotlight.addEventListener('focusout', (event) => {
      if (spotlight.contains(event.relatedTarget)) return;
      focusInside = false;
      scheduleAutoplay();
    });
    spotlight.addEventListener('touchstart', (event) => {
      stopAutoplay();
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    spotlight.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) >= 44) showSlide(activeIndex + (distance < 0 ? 1 : -1));
      scheduleAutoplay();
    }, { passive: true });
    document.addEventListener('visibilitychange', scheduleAutoplay);
    reducedMotion.addEventListener('change', () => {
      scheduleAutoplay();
    });

    showSlide(0);
    scheduleAutoplay();
  });

  } catch(e) { console.error(e); }
})();
})();
